import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: "Gustavo Pereyra",
      location: "Dueño de auto (CABA)",
      quote: "Antes me costaba llegar a fin de mes con un solo ingreso. Poner mi auto a trabajar con ARRANK! fue una decisión clave. Me despreocupo porque tienen todo bajo control, y con lo que gano mensualmente pude hasta empezar a pagar un crédito. Súper recomendable.",
      avatar: "👨‍💼",
      rating: 5
    },
    {
      name: "Natalia Bustos",
      location: "Emprendedora (CABA)",
      quote: "Vi que un amigo ganaba bien con su auto sin manejarlo, y me animé a invertir. Compré un auto exclusivamente para ponerlo a trabajar con ARRANK! y fue una de las mejores decisiones que tomé. En poco tiempo ya recuperé parte de la inversión.",
      avatar: "👩‍💼",
      rating: 5
    },
    {
      name: "Claudia Santillán",
      location: "Dueña de auto (La Plata)",
      quote: "Tenía mi auto parado en el garaje y hoy me genera un ingreso fijo todos los meses sin mover un dedo. ¡ARRANK! se ocupa de todo y eso me permitió dedicarme a terminar la carrera que había dejado pendiente.",
      avatar: "👩‍🎓",
      rating: 5
    },
    {
      name: "Roberto Martinez",
      location: "Jubilado (Córdoba)",
      quote: "Como jubilado necesitaba ingresos extra sin complicarme la vida. ARRANK! me dio esa solución perfecta. Mi auto trabaja mientras yo descanso, y los pagos siempre llegan a tiempo. Es como tener una jubilación complementaria.",
      avatar: "👨‍🦳",
      rating: 5
    },
    {
      name: "María González",
      location: "Ama de casa (Rosario)",
      quote: "Decidimos poner nuestro segundo auto a trabajar para ahorrar para la casa propia. En 8 meses ya juntamos el 40% de lo que necesitábamos. Los chicos de ARRANK! son súper responsables y transparentes con todo.",
      avatar: "👩‍🦰",
      rating: 5
    },
    {
      name: "Diego Fernández",
      location: "Empleado público (Mendoza)",
      quote: "Trabajo en el estado y mi sueldo no me alcanzaba. Con ARRANK! pude duplicar mis ingresos mensuales sin esfuerzo extra. El auto que tenía guardado ahora es mi mejor inversión. Lo recomiendo a todos mis compañeros.",
      avatar: "👨‍💻",
      rating: 5
    },
    {
      name: "Carmen López",
      location: "Docente (Tucumán)",
      quote: "Soy maestra y siempre busqué ingresos extra en las vacaciones. Con ARRANK! mi auto genera dinero todo el año, incluso cuando no estoy trabajando. Es la tranquilidad económica que siempre busqué.",
      avatar: "👩‍🏫",
      rating: 5
    },
    {
      name: "Andrés Morales",
      location: "Comerciante (Salta)",
      quote: "Tengo un negocio y necesitaba capital de trabajo. En lugar de pedir un préstamo, puse mi auto con ARRANK! y obtuve un flujo de ingresos constante que me ayudó a hacer crecer el negocio sin intereses.",
      avatar: "👨‍🤝‍👨",
      rating: 5
    },
    {
      name: "Lucía Ramírez",
      location: "Estudiante universitaria (Buenos Aires)",
      quote: "Mis papás me compraron un auto para la facultad, pero casi no lo uso por el transporte público. Con ARRANK! ahora el auto paga sus propios gastos y me queda dinero extra para mis estudios.",
      avatar: "👩‍🎓",
      rating: 5
    },
    {
      name: "Fernando Castro",
      location: "Técnico (Neuquén)",
      quote: "Trabajo por turnos y mi auto queda muchas horas sin usar. ARRANK! me mostró cómo convertir esas horas muertas en ingresos reales. Ahora mi auto trabaja cuando yo descanso. Genial la propuesta.",
      avatar: "👨‍🔧",
      rating: 5
    }
  ];

  const renderStars = (rating: number) => {
    return '★'.repeat(rating);
  };

  return (
    <section 
      id="testimonios" 
      className="section-hyper scroll-snap-section testimonials-section"
    >
      <div className="section-content-hyper">
        <h2 className="section-title-hyper">Lo que dicen nuestros clientes</h2>
        
        <div className="testimonials-carousel">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: '.swiper-button-next-custom',
              prevEl: '.swiper-button-prev-custom',
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop={true}
            centeredSlides={true}
            className="testimonials-swiper"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={`${testimonial.name}-${index}`}>
                <div className="testimonial-card active">
                  <div className="testimonial-content">
                    <div className="testimonial-header">
                      <div className="author-avatar">{testimonial.avatar}</div>
                      <div className="author-info">
                        <h4 className="author-name">{testimonial.name}</h4>
                        <p className="author-location">{testimonial.location}</p>
                        <div className="testimonial-rating">
                          {renderStars(testimonial.rating)}
                        </div>
                      </div>
                    </div>
                    <div className="quote-icon">"</div>
                    <p className="testimonial-quote">{testimonial.quote}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            
            {/* Botones de navegación personalizados */}
            <div className="swiper-button-prev-custom carousel-btn carousel-btn-prev">‹</div>
            <div className="swiper-button-next-custom carousel-btn carousel-btn-next">›</div>
          </Swiper>
        </div>

        <div className="testimonials-cta">
          <h3 className="cta-title">¿Te interesa ser parte de Arrank?</h3>
          <p className="cta-subtitle">Sumate a cientos de personas que ya generan ingresos con nosotros</p>
          <div className="testimonials-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Clientes satisfechos</span>
            </div>
            <div className="stat">
              <span className="stat-number">4.9</span>
              <span className="stat-label">Rating promedio</span>
            </div>
            <div className="stat">
              <span className="stat-number">$150K+</span>
              <span className="stat-label">Ingresos mensuales generados</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
